import styled from 'styled-components';

export const EmptyHelperText = styled.span`
  opacity: 0;
  pointer-events: none;

  &:before {
    content: '.';
  }
`;
